


export interface IClaims {
  user_id: number;
  client_token: string;
  first_name: string;
  surname: string;
  email: string;
  exp?: number;
}

export enum StorageKeys {
  session_token = 'session-token',
  refresh_token = 'refresh-token',
  cart = 'cart',
  app_version_check = 'app-version-check',
}


export enum Platforms {
  android = "ANDROID",
  ios = "IOS",
  web = "WEB",
}
